// extracted by mini-css-extract-plugin
export default {"plain-text":"v28CyGRxxX","plainText":"v28CyGRxxX"};